import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import styles from './faq.css'

type QuestionProps = {
  question: string
  answer: string
}

const Question = ({ question, answer }: QuestionProps): JSX.Element => {
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.question} key={question}>
      <button onClick={() => setOpen(!open)} className={styles.header}>
        <p>{question}</p>
        <span className={open ? styles.iconOpen : styles.icon} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            dangerouslySetInnerHTML={{ __html: answer }}
            className={styles.content}
          />
        )}
      </AnimatePresence>
    </div>
  )
}

type FaqProps = {
  title?: string
  questions?: Array<QuestionProps>
}

const Faq = ({ title, questions }: FaqProps): JSX.Element => (
  <div className={styles.wrapper}>
    <h2>{title}</h2>
    {questions && questions.map(Question)}
  </div>
)

export default Faq
